import * as ExpoClipboard from 'expo-clipboard';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import useTimer from '@/hooks/useTimer';
import Icon from '../Unistyles/Icon';

type CopyTextButtonProps = {
  defaultButtonText?: string;
  temporaryButtonText?: string;
  textToCopy: string;
  duration?: number;
};

export const COPIED_TO_CLIPBOARD_TEXT = 'Copied to Clipboard';

export default function CopyTextButton({
  defaultButtonText = 'Copy to Clipboard...',
  temporaryButtonText = COPIED_TO_CLIPBOARD_TEXT,
  textToCopy,
  duration = 1000,
}: CopyTextButtonProps) {
  const [text, trigger] = useTimer(defaultButtonText, duration);
  const onPress = () => {
    trigger(temporaryButtonText);
    ExpoClipboard.setStringAsync(textToCopy);
  };
  return (
    <Item onPress={onPress} testID="CopyTextButton">
      <Icon name="copy-outline" />
      <Text>{text}</Text>
    </Item>
  );
}
